import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { putAPI_UpdateMissedResponseStatus } from '../../../../../constants/APIs';

const UpdateStatus = ({
    id,
    value,
    userName
}) => {
    const handleUpdateStatus = () => {
        var body = {
            CurrentStatus: value,
            StatusUpdatedBy: userName
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_UpdateMissedResponseStatus}/${id}`,
            data: body,
        }).then(
            (res) => {
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            },
            (error) => {
                console.log(error);
            }
        );
    }
    return (<Fragment>
        <Button
            size="xs"
            outline
            className="ml-2 btn-round btn-out"
            color='primary'
            // color={value === "Updated" ? "success" : "info"}
            onClick={() => handleUpdateStatus()}><i className={
                value === "Updated"
                    ? 'iconsminds-up-1 mr-1'
                    : value === "Open"
                        ? 'iconsminds-right-1 mr-1'
                        : 'iconsminds-down-1 mr-1'} />
            {value === 'Updated' ? 'Resolve ' : value === 'Open' ? 'Open' : value === 'Ignored' ? 'Ignore' : ''}</Button>
    </Fragment>)
}

const mapStateToProps = ({ settings }) => {
    const { userName } = settings;
    return { userName };
};
export default injectIntl(
    connect(mapStateToProps, {})(UpdateStatus)
);